import FoodEditorModal from "./FoodEditorModal.react";
import FoodEditorModalContent from "./FoodEditorModalContent.react";

export {
    FoodEditorModalContent
}

export default FoodEditorModal;
